import { api } from ".";

const basePath = "/terminal";

export const terminalRegistration = async ({
  companyCode,
  terminalCode,
  name,
  location,
}: any) => {
  try {
    const res = await api.post(`${basePath}/registration-start`, {
      companyCode,
      terminalCode,
      name,
      location,
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const getTerminalList = async ({
  pageNumber,
  limit,
  sort,
  name,
  locate,
} : {
  pageNumber?: number;
  limit?: number;
  sort?: string;
  locate?: string;
  name?: string;
}) => {
  try {
    const params: Record<string, any> = {};
    if (pageNumber !== undefined) params.pageNumber = pageNumber;
    if (limit !== undefined) params.limit = limit;
    if (sort !== undefined) params.sort = sort;
    if (name !== undefined) params.name = name;
    if (locate !== undefined) params.locate = locate;

    const res = await api.get(`${basePath}/list`, { params });
    return res;
  } catch (error) {
    return error;
  }
};

export const deleteTerminal = async ({ id }: any) => {
  try {
    const res = await api.delete(`${basePath}`, {
      data: { _id: id },
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const updateTerminalById = async ({ id, updates }: any) => {
  try {
    const res = await api.put(`${basePath}`, {
      _id: id,
      ...updates,
    });
    return res;
  } catch (error) {
    console.error("Error updating user:", error);
    return error;
  }
};

export const getLocateList = async () => {
  try {
    const res = await api.get(`${basePath}/locate`);
    return res;
  } catch (error) {
    return error;
  }
};

export const getTerminalSelectData = async () => {
  try {
    const res = await api.get(`${basePath}/select-data`);
    return res;
  } catch (error) {
    return error;
  }
};
